import dayjs from 'dayjs';
import duration from 'dayjs/plugin/duration';

export function formatDuration(seconds: number) {
  dayjs.extend(duration);
  const date = dayjs.duration(seconds, 'seconds');

  const hh = String(date.hours());
  const mm = String(date.minutes()).padStart(2, '0');
  const ss = String(date.seconds()).padStart(2, '0');

  if (date.asHours() >= 1) {
    return `${hh}:${mm}:${ss}`;
  }

  return `${mm}:${ss}`;
}
